import {BinaryStrategyTypes, BinaryStrategy} from './BinaryStrategyDto';
import {ManualStrategyContext, ManualStrategy} from './ManualStrategyDto';
import {AIDrivenStrategy} from './AIDrivenStrategyDto';
import {
  SceneDetectionStrategyContext,
  SceneDetectionStrategy,
} from './SceneDetectionStrategyDto';

type BinaryStrategiesContext = {
  binaryId: string;
  datasetId: string;
  projectId: string;
  activeStrategyName: BinaryStrategyTypes;

  strategiesContext: {
    cleverIADriven: {};
    sceneDetection: {
      detectorThreshold: SceneDetectionStrategyContext['sceneDetectorThreshold'];
    };
    manual: {
      segments: ManualStrategyContext['segments'];
      frameExtractionTimes: ManualStrategyContext['frameExtractionTimes'];
      captureFramesEveryInSeconds: ManualStrategyContext['captureFramesEveryInSeconds'];
    };
  };
};

export class BinaryStrategies {
  private _binaryId: string;
  private _datasetId: string;
  private _strategies: BinaryStrategy[] = [];

  private _activeStrategy: BinaryStrategy;

  constructor({
    binaryId,
    projectId,
    datasetId,
    activeStrategyName,

    strategiesContext,
  }: BinaryStrategiesContext) {
    this._binaryId = binaryId;
    this._datasetId = datasetId;

    const {sceneDetection, manual} = strategiesContext;
    this._strategies.push(
      new AIDrivenStrategy({
        projectId,
      }),
      new SceneDetectionStrategy({
        sceneDetectorThreshold: sceneDetection.detectorThreshold,
      }),
      new ManualStrategy({
        segments: manual.segments,
        frameExtractionTimes: manual.frameExtractionTimes,
        captureFramesEveryInSeconds: manual.captureFramesEveryInSeconds,
      })
    );

    this._activeStrategy = this.getStrategyByName(activeStrategyName);
    this._activeStrategy.enable();
  }

  get AI_DRIVEN_STRATEGY() {
    return this.getStrategyByName('AI-driven') as AIDrivenStrategy;
  }

  get SCENE_DETECTION_STRATEGY() {
    return this.getStrategyByName('Scene detection') as SceneDetectionStrategy;
  }

  get MANUAL_STRATEGY() {
    return this.getStrategyByName('Manual') as ManualStrategy;
  }

  getStrategyByName(name: BinaryStrategyTypes) {
    return this._strategies.find(
      strategy => strategy.getName() === name
    ) as BinaryStrategy;
  }

  getActiveStrategy() {
    return this._activeStrategy;
  }

  generateImages() {
    return this.getActiveStrategy().generateImages(this._datasetId, this._binaryId);
  }
}
